"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconNotification', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15,10.29s-1-.55-1-1.38V5.82a6,6,0,0,0-12,0V8.91c0,.83-1,1.38-1,1.38a1,1,0,0,0-.53.88v1.31a1,1,0,0,0,1,1H5.16a3,3,0,0,0,5.74,0h3.63a1,1,0,0,0,1-1V11.17A1,1,0,0,0,15,10.29ZM2.74,11.49A3.51,3.51,0,0,0,4,8.91V5.82A4,4,0,0,1,8,2a4,4,0,0,1,4,3.82V8.91a3.51,3.51,0,0,0,1.24,2.58Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M18.4,13.56S17,12.82,17,11.72V8a7.09,7.09,0,0,0-6-6.91V1A1,1,0,0,0,9,1v.08A7.08,7.08,0,0,0,3,8v3.73c0,1.12-1.43,1.83-1.44,1.84a1,1,0,0,0-.57.89v1.49a1,1,0,0,0,1,1H6.16a4,4,0,0,0,7.69,0H18a1,1,0,0,0,1-1V14.45A1,1,0,0,0,18.4,13.56ZM10,17.94a2,2,0,0,1-1.72-1h3.44A2,2,0,0,1,10,17.94Zm-6.87-3A4.06,4.06,0,0,0,5,11.72V8a5.12,5.12,0,0,1,5-5,5.13,5.13,0,0,1,5,5v3.73a4,4,0,0,0,1.89,3.22Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M22.38,16.53S20,15.51,20,14V10.28a8,8,0,0,0-7-8.21V1a1,1,0,0,0-2,0v1a8,8,0,0,0-7.07,8.23V14c0,1.52-2.36,2.53-2.38,2.54a1,1,0,0,0-.62.93V19a1,1,0,0,0,1,1H7.47a4.72,4.72,0,0,0,9.33,0H22a1,1,0,0,0,1-1V17.46A1,1,0,0,0,22.38,16.53ZM12.13,22a2.73,2.73,0,0,1-2.62-2h5.25A2.75,2.75,0,0,1,12.13,22Zm-.2-4H3.07c1.07-.61,2.86-1.94,2.86-4V10.28A6,6,0,0,1,12,4a5.94,5.94,0,0,1,6,6.28V14c0,2.07,1.79,3.4,2.86,4Z'],
  params: {
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M29.46,22.41S27,21.07,27,18.76V12.58A10.93,10.93,0,0,0,17,2V1a1,1,0,0,0-2,0V2C9.45,2.49,4.9,7.13,4.9,12.58v6.18c0,2.29-2.46,3.63-2.48,3.65a1,1,0,0,0-.54.88v2.62a1,1,0,0,0,1,1h7.19a6,6,0,0,0,11.86,0H29a1,1,0,0,0,1-1V23.29A1,1,0,0,0,29.46,22.41ZM16,30a4,4,0,0,1-3.88-3h7.76A4,4,0,0,1,16,30Zm12-5H3.88V23.85a6.4,6.4,0,0,0,3-5.09V12.58C6.9,7.9,11.07,4,16,4a8.93,8.93,0,0,1,9,8.63v6.18a6.4,6.4,0,0,0,3,5.09Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;